// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + ' verplaatst.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + ' actie voltooid.',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + ' actie in uitvoering.',
  accColorPalette: () => 'Kleurenpalet',
  accColorSwatch: () => 'Kleurenstaal',
  accCommandKey: () => 'Opdracht',
  accContextMenuLabel: () => 'acties',
  accControlKey: () => 'Sluiten',
  accPositionAfter: () => 'na',
  accPositionBefore: () => 'voor',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Houd ' +
    p['keyPressed'] +
    ' samen ingedrukt met de Shift-toetsen en gebruik vervolgens de pijltoetsen om de volgorde aan te passen.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Voer een volledige datum als deze: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Voer een maand en jaar in als deze ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Label',
  chart_labelGroup: () => 'Groep',
  chart_labelSeries: () => 'Reeks',
  chart_labelValue: () => 'Waarde',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Selecteer een waarde.',
  checkbox_helpForCheckbox: () => 'Help voor selectievakje',
  checkbox_requiredMessageDetail: () => 'Selecteer een waarde.',
  checkbox_selected: () => 'Selectievakje ingeschakeld',
  checkbox_unselected: () => 'Selectievakje niet ingeschakeld',
  close: () => 'Sluiten',
  collection_apply: () => 'Toepassen',
  collection_cancel: () => 'Annuleren',
  collection_loaded: () => 'Geladen',
  collection_loading: () => 'Bezig met laden',
  collection_noData: () => 'Er zijn geen gegevens om weer te geven.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Formaat van kolom wijzigen',
  collection_resizeColumnMenu: () => 'Formaat van kolom wijzigen...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Voer een getal in tussen ' + p['MIN'] + ' en ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Alle rijen selecteren',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Rij ' + p['ROW_NAME'] + ' selecteren',
  collection_sortAscendingSubMenu: () => 'Oplopend',
  collection_sortColumnMenu: () => 'Kolom sorteren',
  collection_sortDescendingSubMenu: () => 'Aflopend',
  collection_sortDisabled: () => 'Niet sorteerbaar',
  collection_sortEnabled: () => 'Sorteerbaar',
  collection_width: () => 'Breedte',
  colorPicker_label: () => 'Kleurenselectie',
  confirmation: () => 'Bevestiging',
  datePicker_currentDate: () => 'Huidige datum',
  datePicker_goToToday: () => 'Naar vandaag',
  datePicker_label: () => 'Datumkiezer',
  datePicker_month: () => 'Maand',
  datePicker_months: () => 'Maanden',
  datePicker_next: () => 'Volgende',
  datePicker_nextDecade: () => 'Volgend decennium',
  datePicker_nextMonth: () => 'Volgende maand',
  datePicker_prev: () => 'Vorige',
  datePicker_prevDecade: () => 'Vorig decennium',
  datePicker_prevMonth: () => 'Vorige maand',
  datePicker_restricted: () => 'Beperkt',
  datePicker_selected: () => 'Geselecteerd',
  datePicker_today: () => 'Vandaag',
  datePicker_weekNum: (p: { NUM: string }) => 'Week ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Weeknummer',
  datePicker_year: () => 'Jaar',
  datePicker_years: () => 'Jaar',
  diagram_promotedLink: () => '1 koppeling',
  diagram_promotedLinkAriaDesc: () => 'Indirect',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' koppelingen',
  error: () => 'Fout',
  expandableList_expandCollapseInstructionText: () =>
    'Gebruik de pijltoetsen om uit te vouwen en samen te vouwen',
  expandableList_groupCollapse: () => 'Samengevouwen',
  expandableList_groupExpand: () => 'Uitgevouwen',
  filePicker_addFiles: () => 'Bestanden toevoegen',
  filePicker_dropzonePrimaryText: () => 'Slepen en neerzetten',
  filePicker_dropzoneSecondaryText: () => 'Selecteer een bestand of zet er een hier neer.',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecteer bestanden of zet deze hier neer.',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'U kunt geen bestanden uploaden van dit type: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Upload één bestand per keer',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'U kunt geen bestanden uploaden van het type ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'onbekend',
  formControl_clear: () => 'Wissen',
  formControl_day: () => 'Dag',
  formControl_empty_segment: () => 'Leeg',
  formControl_helpAvailable: () => 'Help beschikbaar',
  formControl_hide: () => 'Verbergen',
  formControl_hour: () => 'Uur',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'U hebt de limiet ' +
    ((
      { one: new Intl.NumberFormat('nl').format(p['CHARACTER_LIMIT']) + '-character' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('nl').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('nl').format(p['CHARACTER_LIMIT']) + '-character') +
    ' bereikt.',
  formControl_loading: () => 'Bezig met laden',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'U kunt maximaal ' + p['MAX_LENGTH'] + ' tekens invoeren.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximumlengte ' + p['MAX_LENGTH'] + ' is overschreden.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tekens over',
  formControl_millisecond: () => 'Milliseconde',
  formControl_minute: () => 'Minuut',
  formControl_month: () => 'Maand',
  formControl_readOnly: () => 'Alleen lezen',
  formControl_requiredMessageDetail: () => 'Voer een waarde in.',
  formControl_second: () => 'Seconde',
  formControl_selectionExactMessageDetail: (p: { n: string }) => p['n'] + ' waarden selecteren.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'U hebt het selectielimiet van ' + p['max'] + ' bereikt.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Selecteer ' + p['min'] + ' tot ' + p['max'] + ' waarden.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Selecteer ten minste ' + p['min'] + ' waarden.',
  formControl_show: () => 'Tonen',
  formControl_year: () => 'Jaar',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Einde',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Rij',
  gantt_labelStart: () => 'Begin',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Geen overeenkomende sectie gevonden.',
  indexer_keyboardInstructionText: () => 'Druk op Enter om waarde te selecteren.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tussen ' + p['FROM_SECTION'] + ' en ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dubbeltik en houd vast om gebarenmodus te activeren. Sleep vervolgens omhoog of omlaag om waarde aan te passen.',
  info: () => 'Informatie',
  inputColor_selectColor: () => 'Selecteer een kleur.',
  inputDateMask_date_cleared: () => 'Datum gewist',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Leeg',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'jjjj',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Voer een datum op of voor ' + p['max'] + ' in.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Voer een datum op of na ' + p['min'] + ' in.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Voer een geldige datum in.',
  inputDatePicker_instruction: () => 'Klik op Tab om de kalender te openen.',
  inputDatePicker_selectDate: () => 'Selecteer een datum',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Voer een maand en jaar op of voor ' + p['max'] + ' in.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Voer een maand en jaar op of na ' + p['min'] + ' in.',
  inputNumber_converterParseError: () => 'Voer een getal in.',
  inputNumber_decrease: () => 'Verkleinen',
  inputNumber_increase: () => 'Vergroten',
  inputPassword_hidden: () => 'Wachtwoord verborgen',
  inputPassword_hide: () => 'Wachtwoord verbergen',
  inputPassword_show: () => 'Wachtwoord tonen',
  inputSensitiveText_hidden: () => 'Gevoelige tekst verborgen.',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Voer een tijd op of eerder dan ' + p['max'] + ' in.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Voer een tijd op of na ' + p['min'] + ' in.',
  inputTimeMask_time_cleared: () => 'Tijd gewist.',
  labelNone: () => 'Geen',
  list_msgFetchCompleted: () => 'Geladen',
  list_msgFetchingData: () => 'Bezig met laden',
  list_suggestion: () => 'Suggestie',
  menu_stateLoading: () => 'Bezig met laden',
  messageToast_allMessagesClosed: () => 'Alle toastmeldingen zijn gesloten.',
  message_close: () => 'Sluiten',
  message_confirmation: () => 'Gelukt',
  message_error: () => 'Fout',
  message_info: () => 'Informatie',
  message_navigationFromMessagesRegion: () =>
    'Berichtenregio invoeren. Druk op F6 om te navigeren.',
  message_navigationToMessagesRegion: () =>
    'Berichtenregio bevat nieuwe berichten. Druk op F6 om deze te openen.',
  message_navigationToTouch: () => 'Berichtenregio bevat nieuwe berichten.',
  message_warning: () => 'Waarschuwing',
  noData_message: () => 'Geen items om weer te geven',
  overflowItemLabel: () => 'Meer tabbladen',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Dubbeltik om de open pop-up te sluiten.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Pop-up wordt geopend. Druk op F6 om tussen de pop-up en het bijbehorende besturingselement te navigeren.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Pop-up is geopend. Druk op F6 om tussen de pop-up en het bijbehorende besturingselement te navigeren.',
  progressIndeterminate: () => 'In uitvoering',
  radioButton_checked: () => 'Keuzerondje ingeschakeld',
  radioButton_selected: () => 'Keuzerondje geselecteerd',
  radioButton_unchecked: () => 'Keuzerondje niet ingeschakeld',
  radioButton_unselected: () => 'Keuzerondje niet geselecteerd',
  radio_helpForRadio: () => 'Help voor keuzerondje',
  radio_requiredMessageDetail: () => 'Selecteer een waarde.',
  selectMultiple_apply: () => 'Toepassen',
  selectMultiple_back: () => 'Terug',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Gebruik toetsen met pijlen naar links en rechts om geselecteerde waarden te markeren.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    "Klik op 'Backspace' of 'Delete' om de geselecteerd waarde te verwijderen.",
  selectMultiple_selectedValues: () => 'Geselecteerde waarden',
  selectMultiple_showSelectedValues: () => 'Alleen geselecteerde waarden tonen',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' geselecteerde waarden',
  select_addToList: () => 'Toevoegen aan lijst',
  select_addToListAvailable: () => 'Toevoegen aan lijst beschikbaar',
  select_closeDropdown: () => 'Druk op Escape om te sluiten.',
  select_moreSearchOptions: () => 'Meer zoekopties',
  select_moreSearchOptionsAvailable: () => 'Meer zoekopties beschikbaar',
  select_noMatchesFound: () => 'Geen treffers gevonden.',
  select_oneMatchFound: () => 'Eén match gevonden.',
  select_requiredMessageDetail: () => 'Selecteer een waarde.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches gevonden',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' of meer matches gevonden',
  selectorAll_deselectAll: () => 'Alles deselecteren',
  selectorAll_selectAll: () => 'Alles selecteren',
  selector_selected: () => 'Selectievakje ingeschakeld',
  selector_unselected: () => 'Selectievakje niet ingeschakeld',
  sheet_close: () => 'Sluiten',
  switch_off: () => 'Uit',
  switch_on: () => 'Aan',
  tabBarNavigationList_removeCueText: () => 'Verwijderbaar',
  tabBar_tabContainsErrors: () => 'Bevat fouten.',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => p['itemKey'] + ' is verwijderd.',
  tabbar_labelContextMenu: () => 'heeft contextmenu',
  tabbar_labelMoveLeft: () => 'Naar links',
  tabbar_labelMoveRight: () => 'Naar rechts',
  tabbar_labelRemove: () => 'Verwijderen',
  timeComponent_tooltipZoomIn: () => 'Inzoomen',
  timeComponent_tooltipZoomOut: () => 'Uitzoomen',
  timeConverter_parseError: () => 'Voer een afrondingstijd in.',
  train_current: () => 'Huidig',
  train_message_type: () => 'Berichttype',
  train_not_visited: () => 'Niet bezocht',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Stap ' + p['currentStep'] + ' van ' + p['numberOfSteps'],
  train_visited: () => 'Bezocht',
  userAssistance_learnMore: () => 'Meer info',
  userAssistance_required: () => 'Vereist',
  vis_clearSelection: () => 'Selectie wissen',
  vis_drillable: () => 'Inzoombaar',
  vis_invalidData: () => 'Ongeldige gegevens',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' van de ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Selecteren marquee',
  vis_marqueeZoomTooltip: () => 'Zoomen marquee',
  vis_noData: () => 'Er zijn geen gegevens om weer te geven.',
  vis_panTooltip: () => 'Pannen',
  vis_stateCollapsed: () => 'Samengevouwen',
  vis_stateExpanded: () => 'Uitgevouwen',
  vis_stateLoaded: () => 'Geladen',
  vis_stateLoading: () => 'Bezig met laden',
  vis_stateSelected: () => 'Geselecteerd',
  vis_stateUnselected: () => 'Niet geselecteerd',
  warn: () => 'Waarschuwing'
};
export default bundle;
